module.exports = __webpack_public_path__ + "img/DE01517.39244ca6.png";